import React from 'react';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { RootState } from '../../../../app/rootReducer';
import {
  StructuredTaskField,
  StructuredTaskFieldRow,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { dateToString } from '../../utilities/formattingUtilities';

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

export const RenderMIBApplicant = () => {
  const { customerName, gender, birthDate, age } = useSelector(
    state => state.application,
  );
  return (
    <StructuredTaskSection title={Resource.MIB_INQUIRY_DETAILS_SUBTITLE}>
      <StructuredTaskFieldRow>
        <StructuredTaskField
          label={Resource.MIB_APPLICANT_NAME}
          value={customerName}
        />
        <StructuredTaskField
          label={Resource.MIB_APPLICANT_GENDER_AND_AGE}
          value={`${gender}, ${age}`}
        />
        <StructuredTaskField
          label={Resource.MIB_APPLICANT_BIRTH_DATE}
          value={dateToString(birthDate)}
        />
      </StructuredTaskFieldRow>
    </StructuredTaskSection>
  );
};
